import { useLazyQuery } from "@apollo/client";

import { BOOK_A_DEMO_QUERY } from "~/api";

export const useBookDemo = () => {
  const [bookDemo, { loading }] = useLazyQuery(BOOK_A_DEMO_QUERY, {
    fetchPolicy: "network-only",
  });

  const submitBookDemo = async (input: {
    companySize: string;
    product: string;
    message: string;
  }): Promise<boolean> => {
    const { data } = await bookDemo({
      variables: {
        companySize: input.companySize,
        product: input.product,
        message: input.message,
      },
    });
    return data?.getBookDemoQuery ?? false;
  };

  return { submitBookDemo, loading };
};
